import React, {useState} from "react";
import S from './Announcements.module.scss';
import {Carousel} from "@mantine/carousel";
import { announcements } from "../../shared/mock/partners";
import {useNavigate} from "react-router-dom";
import {useDisclosure, useMediaQuery} from "@mantine/hooks";
import {ModalWindow} from "../modal";
import backgroundForCompany1 from "../../shared/assets/images/backgroundForCompany1.png";
import backgroundFooter from "../../shared/assets/images/backgroundFooter.png";
import logistic from "../../shared/assets/images/imgLogistic.png";
import logistic2 from "../../shared/assets/images/imgLogistic2.png";

export const Announcements = () => {
    const navigate = useNavigate();
    const [opened, { open, close }] = useDisclosure(false);
    const [selectedAnnouncement, setSelectedAnnouncement] = useState<any>('');
    const handleOpenModal = (id: any) => {
        setSelectedAnnouncement(id);
        open();
    };

    const isMdScreen = useMediaQuery('(min-width: 992px)');
    const showControls = announcements.length > 1 && !isMdScreen;

    return (
        <div className={S.announcements} id="announcements">
            <div className={S.announcementsContainer}>
                <Carousel
                    classNames={{controls: S.controls, root: S.carouselRoot}}
                    className={S.containerCards}
                    slideSize={{ base: '100%', sm: '100%', md: '50%' }}
                    slideGap={{ base: 'lg', lg: '40px', md: '20px' }}
                    emblaOptions={{ loop: true, align: 'start' }}
                    withControls={showControls}
                    controlsOffset="md"
                >
                    {announcements.map((item: any) => (
                        <>
                            <Carousel.Slide key={item.id}>
                                <div className={S.card}>
                                    <div className={S.backgroundForCompany1}>
                                        {item?.id === 5 ? (
                                            <img src={logistic} alt="logistic"/>
                                        ) : (
                                            <img src={backgroundForCompany1} alt="backgroundForCompany1"/>
                                        )}
                                    </div>
                                    <div className={S.cardBox}>
                                        {item?.status &&
                                            <div
                                                className={`${S.status} ${item?.id === 5 ? S.backgroundLogistics : S.backgroundMain}`}>{item?.status}</div>
                                        }
                                        <div className={S.cardInfoTitle}>
                                        <div className={S.boxTitle}>
                                                <div className={S.year}>{item?.year}</div>
                                                <div className={S.title}>{item.title}</div>
                                            </div>
                                            <div className={`${S.boxDescription} ${item?.id === 5 ? S.colorLogistics : S.colorMain}`}>{item.description}</div>
                                        </div>
                                        <div className={S.divVenue}>
                                            <div className={S.titleVenue}>МЕСТО ПРОВЕДЕНИЯ:</div>
                                            <div className={`${S.textVenue} ${item?.id === 5 ? S.colorLogistics : S.colorMain}`}>{item.location}</div>
                                        </div>
                                        <div className={S.divButtons}>
                                            <button className={`${S.button} ${item?.id === 5 ? S.backgroundLogistics : S.backgroundMain}`} onClick={() => handleOpenModal(item.id)}>РЕГИСТРАЦИЯ</button>
                                            <button className={S.buttonSecond}
                                                    onClick={() => navigate(`/event/${item.titleUrl}`)}>ПОДРОБНЕЕ
                                            </button>
                                        </div>
                                        <div className={S.cardTags}>
                                            {item.tags.map((tag: any) => (
                                                <div id={item.id} className={S.tag}>{tag.tag}</div>
                                            ))}
                                        </div>
                                    </div>
                                    <div className={S.backgroundForCompany2}>
                                        {item?.id === 5 ? (
                                            <img src={logistic2} alt="logistic2"/>
                                        ) : (
                                            <img src={backgroundFooter} alt="backgroundFooter"/>
                                        )}
                                    </div>
                                </div>
                            </Carousel.Slide>
                        </>
                    ))}
                </Carousel>
                <ModalWindow
                    opened={opened}
                    close={close}
                    event={selectedAnnouncement}
                />
            </div>
        </div>
    );
};